import { Controller } from "@hotwired/stimulus"

import { PromoPopupManager } from "../services/promo_popup_manager"

export default class extends Controller {
  recordActivity() {
    PromoPopupManager.recordActivity()
  }

  convert({ params }: { params: { name: string; link: string } }) {
    PromoPopupManager.markConverted(params.name, params.link)
  }

  // Opens a popup by name on demand (admin toolbar), bypassing the manager's cadence.
  show({ params }: { params: { name: string } }) {
    this.dispatch("show", { prefix: "popup", target: window, detail: { name: params.name } })
  }
}
